(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('new-feature', {
            parent: 'entity',
            url: '/new-features?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.new-feature.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-feature/new-feature.html',
                    controller: 'NewFeatureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'startDate,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('new-feature');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('file');
                    return $translate.refresh();
                }]
            }
        })
        .state('new-feature-detail', {
            parent: 'entity',
            url: '/new-features/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.new-feature.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-feature/new-feature-detail.html',
                    controller: 'NewFeatureDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('new-feature');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NewFeature', function($stateParams, NewFeature) {
                    return NewFeature.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('new-feature.new', {
            parent: 'new-feature',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-feature/new-feature-dialog.html',
                    controller: 'NewFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                startDate: new Date(),
                                endDate: new Date(),
                                target: null,
                                image: {},
                                appraisalFirms: [],
                                brokerages: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('new-feature', null, { reload: true });
                }, function() {
                    $state.go('new-feature');
                });
            }]
        })
        .state('new-feature.edit', {
            parent: 'new-feature',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-feature/new-feature-dialog.html',
                    controller: 'NewFeatureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewFeature', function(NewFeature) {
                            return NewFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('new-feature.delete', {
            parent: 'new-feature',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-feature/new-feature-delete-dialog.html',
                    controller: 'NewFeatureDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NewFeature', function(NewFeature) {
                            return NewFeature.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-feature', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
